var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack391({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.77,10.73V5H5.85a2.1,2.1,0,0,1,1,.16,1.25,1.25,0,0,1,.51.53,1.75,1.75,0,0,1,.2.87,1.61,1.61,0,0,1-.33,1.05,1.58,1.58,0,0,1-1,.51,1.37,1.37,0,0,1,.4.32,3.73,3.73,0,0,1,.49.73l.82,1.56H7.13L6.5,9.54A6.11,6.11,0,0,0,6,8.6a1,1,0,0,0-.36-.33,1,1,0,0,0-.48-.09H4.39v2.55Zm.62-3.2H5.73a1.61,1.61,0,0,0,.66-.11.82.82,0,0,0,.36-.33,1,1,0,0,0,.13-.53.91.91,0,0,0-.25-.68,1.06,1.06,0,0,0-.75-.25H4.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.49,10.73V5h.63l2.47,4.51V5h.6v5.73h-.64L9.09,6.22v4.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack391);
export default __webpack_public_path__ + "static/media/Symbol_pack_391.a38c35cc724ef50380efc34385d7ce3f.svg";
export { ForwardRef as ReactComponent };